import React from "react";

import PropTypes from "prop-types";

function Td({ className = "", isActions = false, children }) {
  return (
    <td
      className={`py-2 text-gray-200 group-hover:bg-slate-800 ${className} ${
        isActions ? "h-full flex justify-end space-x-4 px-2" : ""
      }`}
    >
      {children}
    </td>
  );
}

Td.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Td;
